import { reset } from 'redux-form'
import { EDIT_FORM, CLOSE_FORM } from './types'

export const editForm = form => ({ type: EDIT_FORM, form })

export const closeForm = form => dispatch => {
  dispatch({ type: CLOSE_FORM })
  dispatch(reset(form))
}
